<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="新建"
        class="customer-edit"
        width="700px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="navItem"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="ID" prop="id">
              <el-input v-model="navItem.id" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="名称" prop="title">
              <el-input v-model="navItem.title" placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="HREF">
              <el-input v-model="navItem.href" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="菜单类型" prop="category">
              <el-select v-model="navItem.category" clearable placeholder="请选择">
                <el-option
                    v-for="item in categorys"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="上级菜单">
              <el-select v-model="parentName" clearable placeholder="请选择">
                <el-option
                    v-for="item in levelList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.title"
                    @click.native="selectLevel(item)"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="功能" prop="functionName">
              <div style="display: flex;flex-direction: row;">
                <el-input v-model="navItem.functionName" disabled placeholder="请输入" readonly>
                  <el-button slot="append" icon="el-icon-search" @click="$refs.selectSystem.open()"/>
                </el-input>
                <system-function-select ref="selectSystem" @select="selectSystem"/>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="SeqNO" prop="seqNO">
              <el-input v-model="navItem.seqNO" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="图标">
              <el-input v-model="navItem.image" placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="checkId">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import SystemFunctionSelect from "@/views/SystemInfo/systemFunction/SystemFunctionSelect";

  export default {
    name:"SystemNavItemCreate",
    components: {SystemFunctionSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        constant,
        categorys: constant.toSelect(constant.category),
        levelList: [],
        functionIDList: [],
        parentName: "",
        functionName: "",
        functionIndex: "",
        navItem: {
          id: "",
          title: "",
          href: "",
          level: "",
          category: "",
          seqNO: "",
          image: "",
          functionName: "",
          functionID: "",
          parentID: "",
        },
        ruleValidate: {
          id: {required: true, message: "不能为空",trigger: "blur"},
          category: {required: true, message: "不能为空",trigger: "blur"},
          functionName: {required: true, message: "不能为空",trigger: "blur"},
          title: {required: true, message: "不能为空",trigger: "blur"},
          seqNO: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.navItem.id = id;
        this.dialogVisible = true;
        this.getLevelList();
        this.getFunctionIdList();
        this.getParentName();
      },
      selectSystem(row) {
        this.navItem.functionID = row.other;
        this.navItem.functionName = row.label + "(" + row.other +")";
      },
      selectLevel(item) {
        this.navItem.parentID = item.id;
        this.navItem.level = item.level;
      },
      getLevelList() {
        this.$http
          .get("basic", "navItems/firstLevelList")
          .then(resp => {
            this.levelList = resp;
          });
      },
      getFunctionIdList() {
        this.$http
          .get("basic", "functions/list")
          .then(resp => {
            this.functionIDList = resp;
          });
      },
      getFunctionName(id) {
        if(id) {
          this.$http
            .get("basic", `functions/${id}`)
            .then(resp => {
              this.functionName= resp.functionName + "(" + resp.functionIndex + ")";
            });
        }
      },
      getData() {
        this.$http
          .get("basic", `navItems/${this.navItem.id}`)
          .then(resp => {
            this.navItem = resp;
            this.getParentName(this.navItem.parentID);
            this.getFunctionName(this.navItem.functionID);
          });
      },
      getParentName(id) {
        if(id) {
          this.$http
            .get("basic", `navItems/${id}`)
            .then(resp => {
              this.parentName= resp.title;
              this.checkId();
            });
        }
      },

      checkId() {
        this.$http
          .get("basic", `navItems/checkId/${this.navItem.id}`)
          .then(() => {
            this.handleSubmit();
          }).catch(() => {
            this.$message.error("ID已存在");
          });
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "navItems", this.navItem)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
